import React from "react"
import * as quoteModuleStyle from "../styles.module.scss"

const QuoteModule = ({ data }) => {
  return (
    <div className={quoteModuleStyle.quoteModule}>
      <p className={quoteModuleStyle.quoteSymbol}>"</p>
      <div className={quoteModuleStyle.quoteContent}>
        <p className={quoteModuleStyle.quoteText}>
          {data.quote.quote}
          <span className={quoteModuleStyle.quoteClosing}>"</span>
        </p>
        <p className={quoteModuleStyle.quoteAuthor}>{data.author}</p>
        <p className={quoteModuleStyle.quoteAuthorPosition}>{data.position}</p>
      </div>
    </div>
  )
}

export default QuoteModule
